import { Component, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { rxResource } from '@angular/core/rxjs-interop';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { ModalComponent, ModalButton } from '../../../common-components/modal/modal.component';
import { CardsAdminService } from '../../../services/admin/cards-admin.service';

@Component({
  selector: 'app-cards-seeds-tab',
  imports: [TranslocoModule, ModalComponent, ReactiveFormsModule, DatePipe],
  templateUrl: './cards-seeds-tab.component.html',
  styleUrl: './cards-seeds-tab.component.scss'
})
export class CardsSeedsTabComponent {
  // Backend orders by (status, -id) - 'pending' < 'used' alphabetically, so pending rows come first.
  seeds = rxResource({ stream: () => this.cardsAdmin.getSeeds$(), defaultValue: [] });

  showAddModal = signal(false);
  nameEnControl = new FormControl<string>('', { nonNullable: true });
  nameUkControl = new FormControl<string>('', { nonNullable: true });
  quoteEnControl = new FormControl<string>('', { nonNullable: true });
  quoteUkControl = new FormControl<string>('', { nonNullable: true });
  rarityHintControl = new FormControl<string>('', { nonNullable: true });
  themeHintControl = new FormControl<string>('', { nonNullable: true });

  addModalButtons: ModalButton[] = [
    { type: 'secondary', text: this.transloco.translate('Cancel'), onClick: () => this.closeAdd() },
    { type: 'primary', text: this.transloco.translate('cardsAdminAdd'), onClick: () => this.save() }
  ];

  constructor(
    private cardsAdmin: CardsAdminService,
    private transloco: TranslocoService
  ) {}

  openAdd(): void {
    this.nameEnControl.setValue('');
    this.nameUkControl.setValue('');
    this.quoteEnControl.setValue('');
    this.quoteUkControl.setValue('');
    this.rarityHintControl.setValue('');
    this.themeHintControl.setValue('');
    this.showAddModal.set(true);
  }

  closeAdd(): void {
    this.showAddModal.set(false);
  }

  save(): void {
    const nameEn = this.nameEnControl.value.trim();
    const nameUk = this.nameUkControl.value.trim();
    const quoteEn = this.quoteEnControl.value.trim();
    const quoteUk = this.quoteUkControl.value.trim();
    if (!nameEn || !nameUk || !quoteEn || !quoteUk) {
      return;
    }
    this.cardsAdmin
      .createSeed$({
        nameEn,
        nameUk,
        quoteEn,
        quoteUk,
        rarityHint: this.rarityHintControl.value || undefined,
        themeHint: this.themeHintControl.value.trim() || undefined
      })
      .subscribe(() => {
        this.showAddModal.set(false);
        this.seeds.reload();
      });
  }

  // Backend enforces pending-only too (409 seedUsedOrMissing on a used seed, surfaced by the
  // global errors interceptor) - the button is hidden for used rows so this is a defensive no-op.
  deleteSeed(id: number): void {
    this.cardsAdmin.deleteSeed$(id).subscribe(() => this.seeds.reload());
  }
}
